import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LocalStorageService } from '../services';

const VISITED_STEPS_KEY = 'visitedQuestionnaireSteps';

export const useVisitedSteps = () => {
  const location = useLocation();

  const [visitedSteps, setVisitedSteps] = useState<Set<string>>(() => {
    const saved = LocalStorageService.getState<string[]>(VISITED_STEPS_KEY);
    return new Set(saved || []);
  });

  const markStepAsVisited = useCallback((route: string) => {
    if (!route || route === '') return;

    setVisitedSteps((prev) => {
      const newVisited = new Set(prev);
      newVisited.add(route);

      LocalStorageService.setState(VISITED_STEPS_KEY, Array.from(newVisited));

      return newVisited;
    });
  }, []);

  const isStepVisited = useCallback(
    (route: string) => {
      return visitedSteps.has(route);
    },
    [visitedSteps],
  );

  const clearVisitedSteps = useCallback(() => {
    setVisitedSteps(new Set());
    LocalStorageService.clearState(VISITED_STEPS_KEY);
  }, []);

  useEffect(() => {
    const currentRoute = location.pathname.replace('/', '');
    if (currentRoute) {
      markStepAsVisited(currentRoute);
    }
  }, [location.pathname, markStepAsVisited]);

  return {
    markStepAsVisited,
    isStepVisited,
    clearVisitedSteps,
    visitedSteps: Array.from(visitedSteps),
  };
};
